<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);

const strokeClass = computed((): string => `stroke-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 23 22">
    <g clip-path="url(#clip0_404_270)">
      <rect x="1.27783" y="0.5" width="21" height="21" rx="10.5" :class="strokeClass" />
      <path
        d="M12.2255 11.0001L16.4475 15.2194L15.9968 15.6699L11.7747 11.4505L7.55904 15.6636L7.10826 15.2131L11.3303 10.9937L7.10826 6.78071L7.55904 6.33022L11.7811 10.5496L15.9968 6.33022L16.4475 6.78071L12.2255 11.0001Z"
        :class="colorClass"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.9966 6L16.7778 6.78071L12.5558 11.0001L16.7778 15.2194L15.9968 16L11.7747 11.7806L7.55904 15.9937L6.77796 15.2131L10.9999 10.9938L6.77783 6.78083L7.55904 6.00012L11.7809 10.2194L15.9966 6ZM15.9969 6.66044L11.7812 10.8798L7.55904 6.66032L7.43869 6.78058L11.6607 10.9936L7.43857 15.2131L7.55904 15.3335L11.7747 11.1205L15.9968 15.3398L16.1172 15.2194L11.8952 11.0001L16.1172 6.78071L15.9969 6.66044Z"
        :class="colorClass"
      />
      <path
        d="M12.2255 11.0001L16.4475 15.2194L15.9968 15.6699L11.7747 11.4505L7.55904 15.6636L7.10826 15.2131L11.3303 10.9937L7.10826 6.78071L7.55904 6.33022L11.7811 10.5496L15.9968 6.33022L16.4475 6.78071L12.2255 11.0001Z"
        :class="colorClass"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.9966 6L16.7778 6.78071L12.5558 11.0001L16.7778 15.2194L15.9968 16L11.7747 11.7806L7.55904 15.9937L6.77796 15.2131L10.9999 10.9938L6.77783 6.78083L7.55904 6.00012L11.7809 10.2194L15.9966 6ZM15.9969 6.66044L11.7812 10.8798L7.55904 6.66032L7.43869 6.78058L11.6607 10.9936L7.43857 15.2131L7.55904 15.3335L11.7747 11.1205L15.9968 15.3398L16.1172 15.2194L11.8952 11.0001L16.1172 6.78071L15.9969 6.66044Z"
        :class="colorClass"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_404_270">
        <rect width="192" height="4047" :class="colorClass" transform="translate(-168 -1437)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
